// 语言切换：EN / 中文 分段开关。
// 法律条款页（LegalShell）和导航栏共用同一个组件，视觉完全一致。
// 两个选项常驻显示 —— 不做成「显示另一种语言的名字」那种单按钮，
// 因为那样用户看不出当前处于哪种语言，也不知道点下去会变成什么。
import React from 'react';
import { Box, HStack } from '@chakra-ui/react';

const SIZES = {
  sm: { px: 3, py: 1, fontSize: 'xs' },
  md: { px: 3.5, py: 1.5, fontSize: 'sm' },
};

export const LangSwitch = ({ lang, setLang, size = 'sm' }) => {
  const s = SIZES[size] || SIZES.sm;
  return (
    <HStack
      spacing={0.5}
      border="1px solid"
      borderColor="gray.200"
      rounded="full"
      p="3px"
      bg="gray.50"
      flexShrink={0}
    >
      {[
        ['en', 'EN'],
        ['zh', '中文'],
      ].map(([key, label]) => {
        const on = lang === key;
        return (
          <Box
            as="button"
            key={key}
            type="button"
            onClick={() => setLang(key)}
            aria-pressed={on}
            px={s.px}
            py={s.py}
            rounded="full"
            fontSize={s.fontSize}
            fontWeight="semibold"
            lineHeight={1.4}
            bg={on ? 'blue.500' : 'transparent'}
            color={on ? 'white' : 'gray.600'}
            sx={{ transition: 'background 0.2s ease, color 0.2s ease' }}
            _hover={on ? {} : { color: 'blue.600' }}
            _focusVisible={{ outline: 'none', boxShadow: '0 0 0 3px rgba(41,171,226,0.35)' }}
          >
            {label}
          </Box>
        );
      })}
    </HStack>
  );
};

export default LangSwitch;
